module.exports = __webpack_public_path__ + "static/media/server-is-no-available-1.c11a5568.svg";